import { ENDPOINTS } from "../lib/api/endpoints";

export const environment = {
  production: false,
  env: "dev",
  sURL: "https://dev-api.sadmincontrol.com",
  mURL: "https://dev-market.sadmincontrol.com",
  sfrURL: "https://dev-feed-rust.sadmincontrol.com",
  wssURL: "wss://dev-feed-rust.sadmincontrol.com",
  s3URL: "https://s3.eu-west-1.amazonaws.com",
  assetPath: "dev-assets.sadmincontrol.com",
  sbLiveTvURL: "https://e765432.xyz/static/a81b94bd3bf0c81e3f714d8065008cf63fe6551f/getdata.php",
  cacheExpirationTime: 32400000, // 9 hours
  maxHighlightResults: 75,
  endpoints: ENDPOINTS,
  SENTRY_DSN: "https://e4b4db108dc282926d5af6ba6574d61e@o4509648546693120.ingest.us.sentry.io/4509667143647232",
  SENTRY_ENABLED: false,
  tracePropagationTargets: ["localhost", /^https:\/\/dev-api\.sadmincontrol\.com\//, /^https:\/\/dev-market\.sadmincontrol\.com\//],
  casinoUrl: "https://dev.gamexpro.site",
};
